import { reviewService } from '../services'

const defaultGrade={
    metric_1: 1,
    metric_2: 1,
    metric_3: 1,
    metric_4: 1,
    metric_5: 1,
    metric_6: 1,
    metric_7: 1,
    metric_8: 1,
    metric_9: '',
    metric_10: 1,
    status: 1,
    remark: '',
    suggestion: ''
}
const defaultVideoGrade={
    metric_1: 1,
    metric_2: 1,
    metric_3: 1,
    metric_4: 1,
    metric_5: null,
    metric_6: 1,
    metric_7: 1,
    metric_8: 0,
    metric_9: null,
    feedback: '',
    status: 1,
}

export const review = {
    namespaced: true,
    state: {
        all: [],
        loading: true,
        total: 0,
        video_grade:{
            metric_1: 1,
            metric_2: 1,
            metric_3: 1,
            metric_4: 1,
            metric_5: null,
            metric_6: 1,
            metric_7: 1,
            metric_8: 0,
            metric_9: null,
            feedback: '',
            status: 1,
        },
        grade: {
            metric_1: 1,
            metric_2: 1,
            metric_3: 1,
            metric_4: 1,
            metric_5: 1,
            metric_6: 1,
            metric_7: 1,
            metric_8: 1,
            metric_9: '',
            metric_10: 1,
            status: 0,
            remark: '',
            suggestion: ''},
        regional_remark: {
            category_hardware:0,
            category_algorithm:0,
            category_market:0,
            category_demonstration:0,
            remark:'',
            eysip_students:[]
        },
        status:null

    },
    actions: {
        projectSubmission({ commit }) {

            return new Promise((resolve, reject) => {
                commit('PROJECT_SUBMISSION_FETCH')

                reviewService.projectSubmission()
                .then(
                    payload => {
                        commit('PROJECT_SUBMISSION_SUCCESS', payload)
                        resolve("success")
                    },
                    error => {
                        commit('PROJECT_SUBMISSION_FAIL', error)
                        reject(error)
                    }
                );
            })
        },

        getProjects({ commit }, {page}) {
            commit('PROJECT_SET_FETCH')
            reviewService.getProjects(page)
                .then(
                    payload => commit('PROJECT_SET_SUCCESS', payload),
                    error => commit('PROJECT_SET_FAIL', error)
                )
        },
        getProjectById({commit}, {projectId}){
            reviewService.getProject(projectId)
                .then( payload => commit('PROJECT_FETCH_SUCCESS', payload),
                error => commit('PROJECT_FETCH_FAILURE',error)
                )

        },
        setGrade({commit}, {projectId, reviewerId, grade}){
            reviewService.updateOrSaveGrade(projectId,reviewerId,grade)
                .then(payload =>commit('PROJECT_SET_GRADE_SUCCESS', payload),
                    error=>commit('PROJECT_SET_GRADE_FAIL', error))
        },
        getProjectGrades({commit}){
            reviewService.getProjectGrades()
                .then(
                    payload => commit('PROJECT_GRADES_SUCCESS',payload),
                    error => commit('PROJECT_GRADES_FAILURE', error)
                )
        },
        getProjectsVideoCodeEval({commit}){
            reviewService.getProjectsVideoCodeEval()
            .then(payload =>commit('ALLOTED_PROJECTS_SUCCESS',payload),
                error=> commit('ALLOTED_PROJECTS_FAIL',error)
            )
        },
       
        setVideoCodeGrade({commit}, {projectId, reviewerId, grade}){
            reviewService.updateOrSaveVideoCodeGrade(projectId,reviewerId,grade)
                .then(payload =>commit('PROJECT_SET_VIDEO_CODE_GRADE_SUCCESS', payload),
                    error=>commit('PROJECT_SET_VIDEO_CODE_GRADE_FAIL', error))
        },

        getVideoCodeProjects({ commit }, {page}) {
            commit('PROJECT_SET_FETCH')
            reviewService.getVideoCodeProjects(page)
                .then(
                    payload => commit('VIDEO_CODE_SET_SUCCESS', payload),
                    error => commit('VIDEO_CODE_SET_FAIL', error)
                )
        },
        getVideoCodeProjectByID({commit}, {projectId}){
            reviewService.getVideoCodeProjectByID(projectId)
                .then( payload => commit('VIDEO_CODE_FETCH_SUCCESS', payload),
                error => commit('VIDEO_CODE_FETCH_FAILURE',error)
                )

        },
       

    },
    mutations: {
        PROJECT_SUBMISSION_FETCH(state) {
            state.all = { loading: true }
        },
        PROJECT_SUBMISSION_SUCCESS(state, payload) {
            state.all = { items: payload }
        },

        PROJECT_SUBMISSION_FAIL(state, error) {
            state.status = error
        },
        PROJECT_SET_FETCH(state) {
            state.all = { loading: true }
        },
        PROJECT_SET_SUCCESS(state, payload) {
            state.all = { items: payload }
            state.status=null
            if(payload.data[0].eval != null && payload.data[0].eval !=undefined && payload.data[0].eval.length>0){
                state.grade =  payload.data[0].eval[0]
                // if(payload.data[0].eval[0].experts == null)
                // state.grade.experts=[]
            }
            else
                state.grade=Object.assign({}, defaultGrade)
        },

        PROJECT_SET_FAIL(state, error) {
            state.status =  error
        },
        PROJECT_FETCH_SUCCESS(state , payload){
            state.all = { project: payload }
            state.status=null
            if(payload.eval != null && payload.eval !=undefined && payload.eval.length>0)
                state.grade =  payload.eval[0]
            else
                state.grade=Object.assign({}, defaultGrade)
        },
        PROJECT_FETCH_FAILURE(state, error){
            state.status =  error
        },
        
        PROJECT_SET_GRADE_SUCCESS(state, payload) {
          //state ={...state}
          state.status= payload
        },

        PROJECT_SET_GRADE_FAIL(state, error) {
            // state={...state}
            state.status = error
        },
        PROJECT_GRADES_SUCCESS(state,payload){
            state.all ={project_items: payload}
        },
        PROJECT_GRADES_FAILURE(state,error){
            state.all ={error:error}
        },
        ALLOTED_PROJECTS_SUCCESS(state,payload){

            state.loading=false
            state.status = null
            state.all = { items: payload,video_code_projects: payload.data }
            // state.all = { video_code_projects: payload.data }
            if(payload.data[0].prototype_eval != null && payload.data[0].prototype_eval !=undefined && payload.data[0].prototype_eval.length>0){
                state.video_grade =  payload.data[0].prototype_eval[0]
            }
            else
                state.video_grade=Object.assign({}, defaultVideoGrade)


        },
        ALLOTED_PROJECTS_FAIL(state,error){
            state.all ={error}
            state.loading=false
            state.total=0
        },
     
        PROJECT_SET_VIDEO_CODE_GRADE_SUCCESS(state,payload){
            state.status= payload
        },
        PROJECT_SET_VIDEO_CODE_GRADE_FAILURE(state,error){
            state.error= error
        },
        VIDEO_CODE_FETCH_SUCCESS(state , payload){
            state.all = { video_code_projects: payload }
            state.status=null
            if(payload.prototype_eval != null && payload.prototype_eval !=undefined && payload.prototype_eval.length>0)
                state.video_grade =  payload.prototype_eval[0]
            else
                state.video_grade=Object.assign({}, defaultVideoGrade)
        },
        VIDEO_CODE_FETCH_FAILURE(state, error){
            state.status =  error
        },
        VIDEO_CODE_SET_SUCCESS(state, payload) {
            state.all = { items: payload }
            state.status=null
            if(payload.data[0].prototype_eval != null && payload.data[0].prototype_eval !=undefined && payload.data[0].prototype_eval.length>0){
                state.video_grade =  payload.data[0].prototype_eval[0]
                // if(payload.data[0].eval[0].experts == null)
                // state.grade.experts=[]
            }
            else
                state.video_grade=Object.assign({}, defaultVideoGrade)
        },

        VIDEO_CODE_SET_FAIL(state, error) {
            state.status =  error
        },

    }
}
